import type { Tab } from "@po/shared";
import { DataTable } from "../components/DataTable";

/** Account Info's lists (SPEC §8.14): each a plain list with a note on what it holds. */
const LISTS: Partial<Record<Tab, { title: string; note: string }>> = {
  accounts: { title: "Accounts", note: "Sertica's financial accounts, with the technical accounts booking to each and your PO lines on it." },
  "approval-setups": {
    title: "Approval setups",
    note: "The approval levels a PO goes through: each setup's approver roles by level, Sertica's rules for them, and your POs taking it.",
  },
  projects: { title: "Projects", note: "Sertica's projects, with the units each is open to and your requisitions and POs on it." },
  "purchase-types": {
    title: "Purchase types",
    note: "Sertica's purchase types: whether each asks for a project, where it is available, and your requisitions and POs under it.",
  },
  "technical-accounts": {
    title: "Technical accounts",
    note: "Sertica's technical accounts, with the financial account each books to under each purchase type, and your requisition lines on it.",
  },
  vat: { title: "VAT", note: "Sertica's VAT codes and their rates." },
};

export function AccountInfoTab({ tab }: { tab: Tab }) {
  const l = LISTS[tab];
  if (!l) return null;
  return (
    <div className="space-y-4">
      <p className="text-[11.5px] text-muted">{l.note} Only the search applies here.</p>
      <DataTable key={tab} table={tab} title={l.title} lens="plain" />
    </div>
  );
}
